module.exports = __webpack_public_path__ + "static/media/default.0fbf0ccf.svg";